import React, { useState, useEffect } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import dayjs from 'dayjs';
import { WHATSAPP_META_CARD_ENDPOINT } from '../../config/urls';
import { useAuth } from '../../hooks/AuthProvider';
import AppTable from '../../common/app-table';
import typography from '../../cssUtils/typography';

const tenant = localStorage.getItem('tenant');

export default function MetaCardTable({ refreshKey, dateInput }) {
    const { getValidToken } = useAuth();
    const [rowCount, setRowCount] = useState(0);

    const [metaRateData, setMetaRateData] = useState([]);

    const [currency, setCurrency] = useState('');

    const columns = [
        {
            id: 'message_type',
            label: 'Message Type',
            render: (row) => (
                <Typography sx={{ ...typography.bodyLarge, fontWeight: 400 }}>
                    {row.message_type}
                </Typography>
            ),
        },
        {
            id: 'rate',
            label: `Rate${currency ? ` (${currency})` : ''}`,
            render: (row) => (
                <Typography sx={{ ...typography.bodyLarge, fontWeight: 400 }}>
                    {row.rate}
                </Typography>
            ),
        },
        {
            id: 'description',
            label: 'Description',
            render: (row) => (
                <Typography sx={{ ...typography.bodyLarge, fontWeight: 400 }}>
                    {row.description}
                </Typography>
            ),
        },
    ];

    const URL = process.env.NODE_ENV === 'production' ? 'api' : `http://localhost:8000/api`;
    const [controller, setController] = useState({
        page: 0,
        rowsPerPage: 20
    });

    const fetchMetaRateData = async () => {
        let searchDateURL = '';
        if (dateInput) {
        let dateString = dayjs(dateInput).format("YYYY-MM-DD");
        searchDateURL = `&search_date=${dateString}`;
        }

        // Construct query parameters for server-side filtering and pagination
        const queryParams = new URLSearchParams({
        limit: controller.rowsPerPage.toString(),
        offset: (controller.serverSidePage * controller.rowsPerPage).toString()
        });

        const token = await getValidToken();

        const tenant = localStorage.getItem('tenant');
        const headers = {
            "Content-Type": "application/json",
            "X-Tenant-Id": tenant,
            'Authorization': `Bearer ${token}`
        };

        try {
        const response = await fetch(`${WHATSAPP_META_CARD_ENDPOINT}?${queryParams}${searchDateURL}`, {
            headers: headers
        });
        if (!response.ok) {
            throw new Error('Failed to fetch rate data');
        }
        const jsonData = await response.json();

        console.log("GET Meta Rate Data: ", jsonData);

        setMetaRateData(jsonData.results);
        setRowCount(jsonData.count);

        // Set currency from the first row if available
        if (jsonData.results && jsonData.results.length > 0 && jsonData.results[0].currency) {
            setCurrency(jsonData.results[0].currency);
        } else {
            setCurrency('');
        }

        } catch (error) {
        console.error('Error fetching rate data:', error.message);
        }
    };

    useEffect(() => {
        fetchMetaRateData();
    }, [
        controller.serverSidePage,
        controller.rowsPerPage,
        refreshKey,
        dateInput,
    ]);

    // pagination
    const handlePageChange = (event, newPage) => {
        setController(prev => ({
        ...prev,
        page: newPage,
        serverSidePage: newPage  // Sync server-side page with UI page
        }));
    };

    const handleChangeRowsPerPage = (event) => {
        setController(prev => ({
            ...prev,
            rowsPerPage: parseInt(event.target.value, 20),
            page: 0,
            serverSidePage: 0  // Reset to first page
        }));
    };

    return (
        <Box sx={{ p: 3, bgcolor: "#fafafa" }}>
            <AppTable
                columns={columns}
                rows={metaRateData}
                count={rowCount}
                page={controller.page}
                rowsPerPage={controller.rowsPerPage}
                rowsPerPageOptions={[20, 50, 100]}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleChangeRowsPerPage}
                paperSx={{ border: "1px solid #DCDFE5", borderRadius: "12px", mb: 2 }}
                containerSx={{
                    scrollbarWidth: "thin",
                    scrollbarColor: "#C5CEDB #F3F6FB",
                    "&::-webkit-scrollbar": { width: "8px" },
                    "&::-webkit-scrollbar-track": { backgroundColor: "#F3F6FB", borderRadius: "8px" },
                    "&::-webkit-scrollbar-thumb": { backgroundColor: "#C5CEDB", borderRadius: "8px" },
                    "&::-webkit-scrollbar-thumb:hover": { backgroundColor: "#A8B4C7" },
                }}
                rowSx={(row, index) => ({
                    backgroundColor: index % 2 === 0 ? "#F0F5FF" : "#FFFFFF",
                    cursor: "default",
                    "&:hover": { backgroundColor: index % 2 === 0 ? "#F5F5F5" : "#F7F9FC" },
                    "& td": { borderBottom: "none", borderTop: "none" },
                })}
            />
        </Box>
    );
    }
